export const FONT_3D = "/fonts/helvetiker_bold.typeface.json";

export const site = {
  brand: "Sandhya Paudel",
  person: "Sandhya Paudel",
  role: "Developer | Designer | Creator",
  location: "Kathmandu, Nepal",
  email: "paudelsandhya9b@gmail.com",
  github: "https://github.com/paudelsandhya",
  githubHandle: "@paudelsandhya",
  linkedin: "https://www.linkedin.com/in/sandhya-paudel-823215394/",
  instagram: "https://instagram.com/sandhyayaps",
  year: 2026,
  hero: {
    eyebrow: "Developer | Designer | Creator",
    heading: ["I craft digital ", "experiences and products."],
    sub: "Most of the projects in here started because I was bored. Make of that what you will.",
    primaryCtaLabel: "Explore the space",
  },
  exploring: "Web Applications",
  footerNote: "Leave a message for projects.",
  stats: [
    { value: "Deployed?", label: "might regret later" },
    { value: "Bugs?", label: "Just trust me " },
    { value: "Version?", label: "Lol good enough" },
    { value: "Compiled?", label: "Eventually" },
  ],
};

export const works = [
  {
    slug: "readmitiq",
    index: "02",
    title: "ReadmitIQ",
    tag: "ML Dashboard",
    year: "2026",
    role: "Full-Stack + ML",
    stack: ["Flask", "Python", "scikit-learn"],
    description:
      "A machine learning web application that predicts hospital readmission risk using healthcare data. Built with Flask and scikit-learn, the project compares multiple classification models and presents their performance through an interactive dashboard.",
    href: "https://readmitiq-1.onrender.com/",
  },
  {
    slug: "spinenotes",
    index: "03",
    title: "SpineNotes",
    tag: "Product Design & Dev",
    featured: true,
    year: "2026",
    role: "Solo Developer & Designer",
    stack: ["React", "Vite", "Tiptap / ProseMirror", "Excalidraw", "IndexedDB"],
    description:
      "A local-first note-taking application built for the browser. It includes rich text editing, canvas pages, backlinks, file attachments, and mobile support, with all data stored locally using IndexedDB.",
    href: "https://spinenotes.onrender.com/",
  },
  {
    slug: "projectweb",
    index: "04",
    title: "ProjectWeb",
    tag: "Student Portfolio · Mini Apps",
    year: "2025",
    role: "Developer",
    stack: ["HTML", "CSS", "JavaScript"],
    description:
      "A student portfolio website featuring several interactive mini-applications, including a calculator, registration form, and login system. Built to demonstrate front-end development skills through working examples.",
    href: "https://paudelsandhya.github.io/ProjectWeb/",
  },
  {
    slug: "portfolio-site",
    index: "05",
    title: "Portfolio Site",
    tag: "Personal Brand · Web",
    year: "2026",
    role: "Developer",
    stack: ["Node.js serverless", "Vercel"],
    description:
      "A portfolio website developed during the early stages of learning web development. Alongside project showcases, it includes several functional mini-applications built to practice front-end development concepts.",
    href: "https://paudel-sandhya.com.np",
  },
];

export const workspaces = [
  {
    label: "Software Engineering",
    tools: "C#, Java, Python, JavaScript, React, SQL, Git",
    detail: "Building web applications, software solutions, and backend systems.",
  },
  {
    label: "Artificial Intelligence",
    tools: "Python, scikit-learn, Pandas, NumPy",
    detail: "Developing machine learning models and data-driven applications.",
  },
  {
    label: "Product Design",
    tools: "Figma, Design Systems, Prototyping",
    detail: "Designing interfaces, workflows, and digital experiences.",
  },
  {
    label: "Research & Documentation",
    tools: "Notion, Markdown, Technical Writing",
    detail:
      "Documenting ideas, processes, and technical decisions through structured research and clear documentation.",
  },
  {
    label: "Digital Strategy",
    tools: "SEO, Content Strategy, Product Marketing",
    detail: "Improving product visibility, reach, and user engagement.",
  },
];

export const certificates = [
  { title: "Basics of UI/UX", issuer: "Skillup", year: "2025", featured: true, file: "/certificates/Certificate-of-Completion-Basics-of-UI-UX-skillup.pdf" },
  { title: "Introduction to Digital Marketing Fundamentals", issuer: "Skillup", year: "2025", featured: true, file: "/certificates/Certificate-Introduction-to-DIgital-Marketing-Fundamentals-Skillup.pdf" },
  { title: "Reshaping Our Economies", issuer: "PAGE", year: "2026", featured: true, file: "/certificates/Certificate_of_Completion-Reshaping-our-Economies-PAGE.pdf" },
  { title: "Mastering International Climate Negotiations", issuer: "UNCC", year: "2025", file: "/certificates/Certificate_of_Completion-Mastering-International-Climate-Negotiations-UNCC.pdf" },
  { title: "Certificate of Completion", issuer: "UNCC", year: "2025", file: "/certificates/Certificate-of-Completion-UNCC.pdf" },
  { title: "CHAT Course Certificate", issuer: "UNICEF", year: "2025", file: "/certificates/CHAT_Course-certificate-UNICEF.pdf" },
  { title: "Data to End Harmful Practices", issuer: "UNICEF", year: "2025", file: "/certificates/Data-to-end-harmful-practices_Course-certificate-UNICEF.pdf" },
  { title: "Global Education Cluster- Core Coordination Training", issuer: "AGORA / UNICEF", year: "2025", file: "/certificates/Global-Education-Cluster-Core-Coordination-Training-CORE-1-AGORA-UNICEF.pdf" },
  { title: "The Journey to Taming Our Biases", issuer: "UNICEF", year: "2025", file: "/certificates/The-Journey-to-Taming-our-Biases._Certificate-of-Growth-UNICEF.pdf" },
  { title: "Certificate", issuer: "", year: "2025", file: "/certificates/Sandhya-Paudel-Certificate.pdf" },
  { title: "Digital Leadership In Business", issuer: "", year: "", file: "/certificates/Digital-Leadership-In-Business.pdf" },
  { title: "AI Applications in Healthcare", issuer: "", year: "", file: "/certificates/AI-Applications-in-Healthcare.pdf" },
  { title: "AWS Lambda Foundation", issuer: "", year: "", file: "/certificates/AWS-Lambda-Foundation.pdf" },
];

export const journal = [
  {
    group: "Poems",
    items: [
      { slug: "all-my-love", title: "All my love", file: "/writings/poems/All-my-love.pdf" },
      { slug: "all-my-love-ii", title: "All my love (II)", file: "/writings/poems/All-my-love-002.pdf" },
      { slug: "all-my-love-iii", title: "All my love (III)", file: "/writings/poems/All-my-love-III.pdf" },
      { slug: "false-god", title: "False God", file: "/writings/poems/False-God.pdf" },
      { slug: "filth", title: "Filth", file: "/writings/poems/Filth.pdf" },
      { slug: "hugging-your-grave", title: "Hugging your grave", file: "/writings/poems/Hugging-your-grave.pdf" },
      { slug: "mother", title: "Mother", file: "/writings/poems/Mother.pdf" },
      { slug: "regrets", title: "Regrets", file: "/writings/poems/Regrets.pdf" },
      { slug: "floor", title: "floor", file: "/writings/poems/floor.pdf" },
      { slug: "maybe-if-i-slowed", title: "maybe if i slowed", file: "/writings/poems/maybe-if-i-slowed.pdf" },
      { slug: "shes-me", title: "shes me", file: "/writings/poems/shes-me.pdf" },
      { slug: "so-bitter", title: "so bitter", file: "/writings/poems/so-bitter.pdf" },
      { slug: "whispers", title: "whispers", file: "/writings/poems/whispers.pdf" },
      { slug: "your-thorns", title: "your thorns", file: "/writings/poems/your-thorns.pdf" },
    ],
  },
  {
    group: "Monologue",
    items: [{ slug: "the-shape-of-yes", title: "The Shape Of Yes", file: "/writings/monologue/The-Shape-Of-Yes.pdf" }],
  },
  {
    group: "Narration",
    items: [
      { slug: "i-ate-her", title: "I ate her", file: "/writings/narration/I-ate-her.pdf" },
      { slug: "red-rapture", title: "Red Rapture", file: "/writings/narration/Red-Rapture.pdf" },
    ],
  },
];

export let resumeFile = "/resume/ResumeSandhya.pdf";
// Called by the content layer when the admin panel replaces the résumé.
export function setResumeFile(path) {
  resumeFile = path;
}

export const ZONES = [
  { id: "hall", label: "Hall", index: "01", pos: [0, 0, 0], cam: [0, 4.4, 19.5], look: [0, 3.2, 0], caption: site.hero.sub },
  { id: "works", label: "Works", index: "02", pos: [60, 0, 0], cam: [60, 4.6, 17.5], look: [60, 2.6, 0], caption: "projects , spanning full-stack apps, machine learning, and freelance sites. Click into any of them for the write-up and a live link." },
  { id: "skills", label: "Skills", index: "03", pos: [120, 0, 0], cam: [120, 4.6, 17.5], look: [120, 2.8, 0], caption: "Tools and Environments, currently exploring Web Applications." },
  { id: "archive", label: "Archive", index: "04", pos: [180, 0, 0], cam: [180, 4.6, 18.5], look: [180, 3, 0], caption: "13 certificates. Preview inline, or download any of them directly." },
  { id: "resume", label: "Résumé", index: "05", pos: [240, 0, 0], cam: [240, 4.4, 16.5], look: [240, 3, 0], caption: "Developer | Designer | Creator · Kathmandu, Nepal" },
  { id: "library", label: "Library", index: "06", pos: [300, 0, 0], cam: [300, 4.6, 18.5], look: [300, 2.6, 0], caption: `Writing, on the side: ${journal.reduce((n, g) => n + g.items.length, 0)} pieces across poems, a monologue, and narration.` },
  { id: "contact", label: "Contact", index: "07", pos: [360, 0, 0], cam: [360, 4.4, 16.5], look: [360, 2.6, 0], caption: "Fill this in and it'll open a pre-filled email in your mail app or reach out directly below." },
];
